// NOTE selectedid: The currect select date. isMonth and isWeek: which text need to display.
// Date calculation need to be done here and pass it to parent comp.

import React from 'react';

export interface RangeOption {
  value: number;
  unit: 'week' | 'month';
}

interface Props {
  options: RangeOption[];
  selected: RangeOption | null;
  onChange: (option: RangeOption | null, fromDate: Date | null) => void;
  getLanguageString?: (option: RangeOption) => string;
}

export const getFromDate = (option: RangeOption, baseDate: Date = new Date()): Date => {
  // Normalize base date to midnight local time to avoid timezone and clock drift
  const date = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  if (option.unit === 'month') {
    date.setMonth(date.getMonth() + option.value);
  } else {
    date.setDate(date.getDate() + option.value * 7);
  }
  return date;
};

export const DueDateBadge: React.FC<Props> = ({ options, selected, onChange, getLanguageString }) => {
  const baseCls = 'rounded-full border border-indigo-700 px-3 py-1 cursor-pointer hover:bg-indigo-700 text-center';

  return (
    <div className="grid grid-cols-2 w-full gap-2">
      {options.map((opt) => {
        const isSelected = selected?.value === opt.value && selected?.unit === opt.unit;
        const label = getLanguageString
          ? getLanguageString(opt)
          : `${opt.value} ${opt.unit}${opt.value > 1 ? 's' : ''}`;

        return (
          <div
            key={`${opt.value}-${opt.unit}`}
            onClick={() => {
              if (isSelected) {
                onChange(null, null);
              } else {
                onChange(opt, getFromDate(opt));
              }
            }}
            className={`${baseCls}${isSelected ? ' bg-indigo-700' : ''} whitespace-nowrap`}
          >
            <span className="text-neutral-100!">{label}</span>
          </div>
        );
      })}
    </div>
  );
};